import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_av43xzgdd9: FaireBrandEntity = {
  token: "b_av43xzgdd9",
  type: "brand",
  name: "Kos Couture",
  avatarUrl:
    "https://cdn.faire.com/fastly/a573d814e8fe23f9a80b666adfcbf00b74fddd2adc18e928add834164beefa7a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b45d0af82e8634550433668a08ca80ed1db3bc9c8732ed29cbced2afbcdd71c7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a573d814e8fe23f9a80b666adfcbf00b74fddd2adc18e928add834164beefa7a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b45d0af82e8634550433668a08ca80ed1db3bc9c8732ed29cbced2afbcdd71c7.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 74,
  isInsider: true,
  description:
    "Kos Couture was established with the goal of offering elegant, affordable fancy and party wear to fashion-forward individuals in diverse styles and colors. At Kos Couture, we’re committed to providing not only stunning dresses but an exceptional shopping experience—from the moment you order to the moment you step out in a breathtaking outfit for your special occasion.\n\nOur reputation for excellent customer service is built on a foundation of fast shipping and flexible returns, ensuring you can shop with complete confidence. Whether you’re searching for affordable dresses or high-end designer pieces, Kos Couture is here to make every event unforgettable!\n\nCome visit our showroom at 1100 San Julian St, Los Angeles, CA 90015.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.704Z",
    importedBy: "entity-db-cli",
  },
};
